<template>
  <div class="dataScreen">
    <!-- 地图 -->
    <div ref="container" id="container">
      <MapGIS />
      <!-- <div class="div-overlay"></div> -->
    </div>
    <dv-loading v-if="isdialog" class="loadingBox">Loading...</dv-loading>
    <!-- top -->
    <transition name="slide-fade">
      <Header
        v-if="transitions.isHeader"
        :swiechColor="swiechColor"
        class="topWrapBox"
        :sun="sun"
        @child-change="changeValue"
      ></Header>
    </transition>
    <!-- NewLeft -->
    <transition name="slide-fade-left">
      <NewLeft
        v-if="transitions.isLeft"
        :leftObj="leftObj"
        :swiechColor="swiechColor"
        class="leftWrapBox"
      >
      </NewLeft>
    </transition>
    <!-- right -->
    <transition name="slide-fade-right">
      <Right
        v-if="transitions.isRight"
        :rightObj="rightObj"
        :swiechColor="swiechColor"
        class="rightWrapBox"
        @childNumberClick="childNumberClick"
      ></Right>
    </transition>
    <!-- bottom -->
    <transition name="slide-fade-bottom">
      <Bottom
        v-if="transitions.isBottom"
        class="bottomWrapBox"
        @childBtn01Click="childBtn01Click"
        @childBtn02Click="childBtn02Click"
        @childBtn03Click="childBtn03Click"
        @childBtn04Click="childBtn04Click"
        :bottomBtnList="bottomBtnList"
      ></Bottom>
    </transition>
  </div>
</template>

<script>
import Header from "@/components/header";
import NewLeft from "@/components/dataScreen/newLeft/index.vue";
import Right from "@/components/dataScreen/right/index.vue";
import Bottom from "@/components/dataScreen/bottom/index.vue";
import axios from "axios";
import MapGIS from "@/components/GIS-map/Main.vue";
import Pathplan from "@/components/Roads/index.vue"; //预案编辑
import ADSB from "@/components/Roads/ADS-B.vue";
import RoadsPathplan from "@/components/Roads/pathplan.vue"; //预案编辑
import layerManage from "@/components/Layer/index.vue"; //图层管理
import Bookmark from "@/components/Bookmark/index.vue"; //书签管理
import AirplaneReplay from "@/views/airplaneReplay/index.vue"; //飞行回放
import { getDay } from "@/utils/index";

// 计算两点间球面距离（单位：米）
function getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371000; // 地球半径，单位米
    const toRad = deg => deg * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
              Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
}

// 计算轨迹总距离
function getTotalDistance(arr) {
    let total = 0;
    for (let i = 1; i < arr.length; i++) {
        total += getDistance(
            arr[i-1].latitude, arr[i-1].longitude,
            arr[i].latitude, arr[i].longitude
        );
    }
    return total;
}

function cleanPropsWithDistance(obj) {
    for (const key in obj) {
        const arr = obj[key];
        if (Array.isArray(arr)) {
            // 规则1
            if (arr.length === 1) {
                delete obj[key];
                continue;
            }
            // 规则2
            const uniqueSet = new Set(
                arr.map(item => `${item.longitude},${item.latitude},${item.altitude}`)
            );
            if (uniqueSet.size === 1) {
                delete obj[key];
                continue;
            }
            // 规则3
            const totalDistance = getTotalDistance(arr);
            if (totalDistance < 500) {
                delete obj[key];
            }
        }
    }
    return obj;
}

import {
  getIndexHK,
  getPreviousDate,
  getTodayBeginTime,
  getCurrentEndTime,
  getPreviousHour,
  listDeviceOnlineCount,
} from "@/api/DK.js";
export default {
  components: {
    Header,
    NewLeft,
    Right,
    Bottom,
    MapGIS,
  },
  data() {
    var colorArray = [
      {
        top: "#ffa800", //黄
        bottom: "rgba(11,42,84,.3)",
      },
      {
        top: "#1ace4a", //绿
        bottom: "rgba(11,42,84, 0.3)",
      },
      {
        top: "#4bf3ff", //蓝
        bottom: "rgba(11,42,84,.3)",
      },
      {
        top: "#4f9aff", //深蓝
        bottom: "rgba(11,42,84,.3)",
      },
      {
        top: "#b250ff", //粉
        bottom: "rgba(11,42,84,.3)",
      },
    ];
    return {
      isdialog: false, // 加载动画
      swiechColor: "transparent",
      sun: {
        title: "通航飞行管控系统",
      },
      transitions: {
        isHeader: true,
        isLeft: true,
        isRight: true,
        isBottom: true,
      },
      leftObj: {
        leftItem01Obj: {
          subTitle: {
            trainImage: require("@/assets/dataScreen/rectangle.png"),
            title: "近三日数据",
          },
          flopList: [
            { number: [0], textAlign: "center" },
            { number: [0], textAlign: "center" },
            { number: [0], textAlign: "center" },
            { number: [0], textAlign: "center" },
            { number: [0], textAlign: "center" },
            { number: [0], textAlign: "center" },
          ],
          config: {
            oddRowBGC: "transparent", // 奇数行背景色
            evenRowBGC: "rgba(21, 85, 75, 0.2)", // 偶数行背景色
            header: ["公司", "总数", "在线数", "离线数"],
            data: [],
            align: ["center"],
            waitTime: 1500,
            rowNum: 8,
          },
        },
        leftItem02Obj: {
          subTitle: {
            trainImage: require("@/assets/dataScreen/rectangle.png"),
            title: "在线率趋势",
          },
          params: {},
        },
      },
      rightObj: {
        rightItem01Obj: {
          subTitle: {
            trainImage: require("@/assets/dataScreen/rectangle.png"),
            title: "今日飞行统计",
          },
          totalNum: 0, // 总数
          onLineNum: 0, // 在线数
          offLineNum: 0, // 离线数
        },
        rightItem02Obj: {
          subTitle: {
            trainImage: require("@/assets/dataScreen/rectangle.png"),
            title: "设备类型统计",
          },
          parmas: {
            color: [],
            legend: {
              top: "bottom",
              textStyle: {
                color: "#fff",
              },
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            series: [
              {
                name: "设备类型",
                type: "pie",
                radius: ["22%", "70%"],
                center: ["50%", "41%"],
                roseType: "radius",
                label: {
                  normal: {
                    show: true,
                    formatter: "{b}：{c}",
                  },
                  emphasis: {
                    show: true,
                  },
                },
                data: [],
              },
            ],
          },
        },
        rightItem03Obj: {
          subTitle: {
            trainImage: require("@/assets/dataScreen/rectangle.png"),
            title: "单位统计(Top5)",
          },
          parmas: {
            tooltip: {
              show: true,
              formatter: "{b}:{c}架",
            },
            grid: {
              left: "5%",
              top: "0%",
              right: "8%",
              bottom: "8%",
              containLabel: true,
            },

            xAxis: {
              type: "value",
              max: 100, // 设置最大值
              show: false,
              position: "top",
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#fff",
                },
              },
              splitLine: {
                show: false,
              },
            },
            yAxis: [
              {
                type: "category",
                axisTick: {
                  show: false,
                  alignWithLabel: false,
                  length: 5,
                },
                splitLine: {
                  //网格线
                  show: false,
                },
                inverse: "true", //排序
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#fff",
                  },
                },
                data: [],
              },
            ],
            series: [
              {
                name: "数据",
                type: "bar",
                label: {
                  normal: {
                    show: true,
                    position: "right",
                    formatter: "{c}架",
                    textStyle: {
                      color: "white", //color of value
                    },
                  },
                },
                itemStyle: {
                  normal: {
                    show: true,
                    color: function (params) {
                      let num = colorArray.length;
                      return {
                        type: "linear",
                        colorStops: [
                          {
                            offset: 0,
                            color: colorArray[params.dataIndex % num].bottom,
                          },
                          {
                            offset: 1,
                            color: colorArray[params.dataIndex % num].top,
                          },
                          {
                            offset: 0,
                            color: colorArray[params.dataIndex % num].bottom,
                          },
                          {
                            offset: 1,
                            color: colorArray[params.dataIndex % num].top,
                          },
                          {
                            offset: 0,
                            color: colorArray[params.dataIndex % num].bottom,
                          },
                          {
                            offset: 1,
                            color: colorArray[params.dataIndex % num].top,
                          },
                          {
                            offset: 0,
                            color: colorArray[params.dataIndex % num].bottom,
                          },
                          {
                            offset: 1,
                            color: colorArray[params.dataIndex % num].top,
                          },
                          {
                            offset: 0,
                            color: colorArray[params.dataIndex % num].bottom,
                          },
                          {
                            offset: 1,
                            color: colorArray[params.dataIndex % num].top,
                          },
                          {
                            offset: 0,
                            color: colorArray[params.dataIndex % num].bottom,
                          },
                          {
                            offset: 1,
                            color: colorArray[params.dataIndex % num].top,
                          },
                        ],
                        //globalCoord: false
                      };
                    },
                    barBorderRadius: 70,
                    borderWidth: 0,
                    borderColor: "#333",
                  },
                },
                barGap: "0%",
                barCategoryGap: "50%",
                data: [],
              },
            ],
          },
        },
      },
      bottomBtnList: [
        {
          name: "航线规划",
          iconImage: require("@/assets/dataScreen/buttonIcon01.png"),
        },
        {
          name: "飞行回放",
          iconImage: require("@/assets/dataScreen/buttonIcon02.png"),
        },
        {
          name: "ADS-B监测",
          iconImage: require("@/assets/dataScreen/buttonIcon03.png"),
        },
        {
          name: "图层管理",
          iconImage: require("@/assets/dataScreen/buttonIcon04.png"),
        },
      ],
    };
  },
  mounted() {
    let that = this;

    that.getTimeData();
    let start = getTodayBeginTime();
    let end = getCurrentEndTime();
    // 今日飞行数量统计
    getIndexHK({
      beginTime: start,
      endTime: end,
      size: 50,
    })
      .then((res) => {
        console.log(res);
        let result = cleanPropsWithDistance(res.result || {});
        const onLineNum = Object.keys(result).length;
        that.rightObj.rightItem01Obj.totalNum = 510;
        that.rightObj.rightItem01Obj.onLineNum = onLineNum;
        //that.rightObj.rightItem01Obj.offLineNum = 510 - onLineNum;
        window.__JRSJ__ = result;
      })
      .catch((err) => {
        console.error(err);
      });

    let startH = getPreviousHour(0.5);

    // 今日在线数量统计
    getIndexHK({
      beginTime: startH,
      endTime: end,
      size: 150,
    })
      .then((res) => {
        console.log(res);
        let result = cleanPropsWithDistance(res.result || {});
        const onLineNum = Object.keys(result).length;
        that.rightObj.rightItem01Obj.offLineNum = onLineNum;
        window.__JRSJ__ZX = result;
      })
      .catch((err) => {
        console.error(err);
      });

    // 设备类型统计
    axios.get("data/deviceType.json").then((response) => {
      let data = response.data.result || [];
      that.rightObj.rightItem02Obj.parmas.series[0].data =
        data.map((item) => {
          item.itemStyle = { normal: { color: item.color } };
          item.label = { color: item.color };
          return item;
        }) || [];
      that.rightObj.rightItem02Obj.parmas.color = data.map((item) => item.color);
    });
    // 单位统计
    // axios.get("data/company.json").then((response) => {
    //   let data = response.data.result || [];
    //   let xAxisCategoriesValue = data.map((item) => item.name);
    //   let receiveListValue = data.map((item) => item.receive);
    //   let maxValue = Math.max(...receiveListValue) + 20; // 最大值
    //   that.rightObj.rightItem03Obj.parmas.xAxis.max = maxValue;
    //   that.rightObj.rightItem03Obj.parmas.yAxis[0].data = xAxisCategoriesValue || [];
    //   that.rightObj.rightItem03Obj.parmas.series[0].data = receiveListValue || [];
    // });
    // axios.get("data/dayData.json").then((response) => {
    //   let data = response.data.result || [];
    //   let totalNumber = 0;
    //   let dataValue = [];
    //   data.forEach((item) => {
    //     totalNumber += item.onlineNumber;
    //     dataValue.push([
    //       item.corporateName,
    //       item.model,
    //       item.total,
    //       item.onlineNumber,
    //       item.offlineNumber,
    //     ]);
    //   });
    //   // 在线数统计
    //   that.digitalProcessing(totalNumber);
    //   // 公司飞机类型统计
    //   that.leftObj.leftItem01Obj.config = {
    //     oddRowBGC: "transparent", // 奇数行背景色
    //     evenRowBGC: "rgba(21, 85, 75, 0.2)", // 偶数行背景色
    //     header: ["公司", "机型", "总数", "在线数", "离线数"],
    //     data: dataValue,
    //     align: ["center"],
    //     waitTime: 1500,
    //     rowNum: 8,
    //     columnWidth: [175, 105],
    //   };
    // });
    // 在线率趋势
    // axios.get("data/trendData.json").then((response) => {
    //   let dataValue = response.data.result || [];
    //   that.leftObj.leftItem02Obj.params = {
    //     chart: {
    //       type: "areaspline",
    //       spacing: [10, 10, 10, 10],
    //       backgroundColor: null,
    //     },
    //     title: {
    //       text: null,
    //     },
    //     credits: {
    //       enabled: false, // 去掉版权信息
    //     },
    //     legend: {
    //       enabled: false,
    //     },
    //     xAxis: {
    //       categories: [
    //         this.monthDay(getDay(0)),
    //         this.monthDay(getDay(-1)),
    //         this.monthDay(getDay(-2)),
    //         this.monthDay(getDay(-3)),
    //         this.monthDay(getDay(-4)),
    //         this.monthDay(getDay(-5)),
    //         this.monthDay(getDay(-6)),
    //         this.monthDay(getDay(-7)),
    //       ],
    //       labels: {
    //         style: {
    //           color: "white",
    //         },
    //       },
    //       lineWidth: 0.8,
    //     },
    //     yAxis: {
    //       title: {
    //         text: null,
    //       },
    //       gridLineDashStyle: "longdash",
    //       gridLineColor: "rgba(4, 187, 255, 0.5)",
    //       labels: {
    //         format: "{value} %",
    //         style: {
    //           color: "white",
    //         },
    //       },
    //     },
    //     tooltip: {
    //       shared: true,
    //       valueSuffix: "%",
    //     },
    //     plotOptions: {
    //       areaspline: {
    //         lineColor: "#47E6C5",
    //       },
    //       series: {
    //         animation: {
    //           duration: 3000,
    //           easing: "easeOutBounce",
    //         },
    //         marker: {
    //           fillColor: "#fff",
    //           lineWidth: 2,
    //           lineColor: "#47E6C5", // inherit from series
    //           symbol: "circle", //曲线点类型："circle", "square", "diamond", "triangle","triangle-down"，默认是"circle"
    //         },
    //       },
    //     },
    //     series: [
    //       {
    //         name: "在线率",
    //         color: {
    //           linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
    //           stops: [
    //             [0, "rgba(71, 230, 197, 0.5)"],
    //             [1, "rgba(71, 230, 197, 0)"],
    //           ],
    //         },
    //         data: dataValue,
    //       },
    //     ],
    //   };
    // });
  },
  methods: {
    getTimeData(callback) {
      window.__PreviousDate__ = window.__PreviousDate__ || 1;

      let that = this;
      let start = getPreviousDate(that.getDays(window.__PreviousDate__));
      let end = getCurrentEndTime();

      console.log("start", start);
      console.log("end", end);
      let dataArr = ["", "近三日", "近一周", "近俩周", "近一个月"];
      let result = window[dataArr[window.__PreviousDate__]];

      that.leftObj.leftItem01Obj.subTitle.title =
        dataArr[window.__PreviousDate__] + "数据";

      // if (result) {
      //   const onLineNum = Object.keys(result).length;
      //   // 在线数统计
      //   that.digitalProcessing(onLineNum);
      //   if (typeof callback == "function") {
      //     callback("", result);
      //   }
      //   return;
      // }
      that.isdialog = true;
      getIndexHK({
        beginTime: start,
        endTime: end,
        size: 50,
      })
        .then((res) => {
          that.isdialog = false;
          console.log(res);
          let result = res.result || {};
          const onLineNum = Object.keys(result).length;
          // 在线数统计
          that.digitalProcessing(onLineNum);
          window[dataArr[window.__PreviousDate__]] = result; //缓存

          if (typeof callback == "function") {
            callback("", result);
          }
        })
        .catch((err) => {
          that.isdialog = false;
          console.error(err);
        });

      listDeviceOnlineCount({
        beginTime: start,
        endTime: end,
      })
        .then((res) => {
          let data = res.result || [];
          let dataValue = [];
          data.forEach((item) => {
            dataValue.push([
              item.deviceGroupName,
              item.count,
              item.countOnLine,
              item.count - item.countOnLine,
            ]);
          });
          // 公司飞机类型统计
          that.leftObj.leftItem01Obj.config = {
            oddRowBGC: "transparent", // 奇数行背景色
            evenRowBGC: "rgba(21, 85, 75, 0.2)", // 偶数行背景色
            header: ["公司", "飞机总数", "在线数", "离线数"],
            data: dataValue,
            align: ["center"],
            waitTime: 1500,
            rowNum: 8,
            columnWidth: [240, 105],
          };

          let categories = data.map((p) => p.deviceGroupName);
          let dataArr = data.map((p) => {
            let r = p.countOnLine / p.count;
            return Number((r * 100).toFixed(1));
          });

          console.log("dataArr", dataArr);
          //趋势率
          that.leftObj.leftItem02Obj.params = {
            chart: {
              type: "areaspline",
              spacing: [10, 10, 10, 10],
              backgroundColor: null,
            },
            title: {
              text: null,
            },
            credits: {
              enabled: false, // 去掉版权信息
            },
            legend: {
              enabled: false,
            },
            xAxis: {
              categories: categories,
              labels: {
                style: {
                  color: "white",
                },
              },
              lineWidth: 0.8,
            },
            yAxis: {
              title: {
                text: null,
              },
              gridLineDashStyle: "longdash",
              gridLineColor: "rgba(4, 187, 255, 0.5)",
              labels: {
                format: "{value} %",
                style: {
                  color: "white",
                },
              },
            },
            tooltip: {
              shared: true,
              valueSuffix: "%",
            },
            plotOptions: {
              areaspline: {
                lineColor: "#47E6C5",
              },
              series: {
                animation: {
                  duration: 3000,
                  easing: "easeOutBounce",
                },
                marker: {
                  fillColor: "#fff",
                  lineWidth: 2,
                  lineColor: "#47E6C5", // inherit from series
                  symbol: "circle", //曲线点类型："circle", "square", "diamond", "triangle","triangle-down"，默认是"circle"
                },
              },
            },
            series: [
              {
                name: "在线率",
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "rgba(71, 230, 197, 0.5)"],
                    [1, "rgba(71, 230, 197, 0)"],
                  ],
                },
                data: dataArr,
              },
            ],
          };

          //单位类型
          if (!window.__DWLX__) {
            window.__DWLX__ = true;
            data.sort((a, b) => b.count - a.count);
            // 2. 提取前五项数据
            const topFive = data.slice(0, 5);
            let sum = 510;
            let xAxisCategoriesValue = [];
            let receiveListValue = [];
            let hasCount = 0;
            for (let i = 0; i < topFive.length; i++) {
              xAxisCategoriesValue.push(topFive[i].deviceGroupName);
              receiveListValue.push(topFive[i].count);
              hasCount += topFive[i].count;
            }

            xAxisCategoriesValue.push("其他单位");
            receiveListValue.push(sum - hasCount);

            // let xAxisCategoriesValue = data.map((item) => item.name);
            // let receiveListValue = data.map((item) => item.receive);
            let maxValue = Math.max(...receiveListValue) + 20; // 最大值
            that.rightObj.rightItem03Obj.parmas.xAxis.max = maxValue;
            that.rightObj.rightItem03Obj.parmas.yAxis[0].data =
              xAxisCategoriesValue || [];
            that.rightObj.rightItem03Obj.parmas.series[0].data = receiveListValue || [];
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDays(value) {
      if (value == 1) {
        return 3;
      }
      if (value == 2) {
        return 7;
      }
      if (value == 3) {
        return 14;
      }
      if (value == 4) {
        return 30;
      }
      return 1;
    },
    // 在线数处理
    digitalProcessing(num) {
      let that = this;
      that.leftObj.leftItem01Obj.flopList = [
        { number: [Math.floor(num / 100000) % 10], textAlign: "center" },
        { number: [Math.floor(num / 10000) % 10], textAlign: "center" },
        { number: [Math.floor(num / 1000) % 10], textAlign: "center" },
        { number: [Math.floor(num / 100) % 10], textAlign: "center" },
        { number: [Math.floor(num / 10) % 10], textAlign: "center" },
        { number: [num % 10], textAlign: "center" },
      ];
    },
    // 数组切割保留-月-日
    monthDay(arr) {
      arr = arr.split("-");
      return `${arr[1]}-${arr[2]}`;
    },
    // 航线规划
    childBtn01Click() {
      this.$bus.$emit("foldClick-left", false);
      this.$bus.$emit("foldClick-right", false);
      this.$dialog.closeAll();
      this.$dialog.open({
        id: "航线规划",
        title: "航线规划",
        theme: "feature-dialog",
        area: {
          height: "820px",
          width: "400px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: RoadsPathplan,
        },
      });
    },
    // 飞行回放
    childBtn02Click() {
      this.$bus.$emit("foldClick-left", false);
      this.$bus.$emit("foldClick-right", false);
      this.$dialog.closeAll();
      var ins = this.$dialog.getDialog("飞行回放");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "飞行回放",
        title: "飞行回放",
        theme: "feature-dialog",
        area: {
          height: "600px",
          width: "1200px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: AirplaneReplay,
        },
      });
    },
    // 航行管理
    childBtn03Click() {
      this.$bus.$emit("foldClick-left", false);
      this.$bus.$emit("foldClick-right", false);
      this.$dialog.closeAll();
      var ins = this.$dialog.getDialog("气象模拟");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "ADS-B监测",
        title: "ADS-B监测",
        theme: "feature-dialog",
        area: {
          height: "826px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: ADSB,
        },
      });
    },
    // 图层管理
    childBtn04Click() {
      this.$bus.$emit("foldClick-left", false);
      this.$bus.$emit("foldClick-right", false);
      this.$dialog.closeAll();
      // this.bookManage();
      // return;
      var ins = this.$dialog.getDialog("图层管理");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "图层管理",
        title: "图层管理",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: layerManage,
        },
      });
    },

    bookManage() {
      var ins = this.$dialog.getDialog("书签管理");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "书签管理",
        title: "书签管理",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: Bookmark,
        },
      });
    },

    // 时间切换(1-今天;2-近一周;3-近一个月;4-近三个月;5-近一年)
    changeValue(value) {
      window.__PreviousDate__ = value;
      this.getTimeData((value, arrLine) => {
        this.$bus.$emit("line-list-change", value, arrLine);
      });
      // this.$bus.$emit("line-list-change", value);
      // let that = this;
      // if (value == 1) {
      //   that.leftObj.leftItem01Obj.subTitle.title = "今日数据";
      //   axios.get("data/dayData.json").then((response) => {
      //     let data = response.data.result || [];
      //     let totalNumber = 0;
      //     let dataValue = [];
      //     data.forEach((item) => {
      //       totalNumber += item.onlineNumber;
      //       dataValue.push([
      //         item.corporateName,
      //         item.model,
      //         item.total,
      //         item.onlineNumber,
      //         item.offlineNumber,
      //       ]);
      //     });
      //     // 在线数统计
      //     that.digitalProcessing(totalNumber);
      //     // 公司飞机类型统计
      //     that.leftObj.leftItem01Obj.config = {
      //       oddRowBGC: "transparent", // 奇数行背景色
      //       evenRowBGC: "rgba(21, 85, 75, 0.2)", // 偶数行背景色
      //       header: ["公司", "机型", "总数", "在线数", "离线数"],
      //       data: dataValue,
      //       align: ["center"],
      //       waitTime: 1500,
      //       rowNum: 8,
      //       columnWidth: [175, 105],
      //     };
      //   });
      // } else if (value == 2) {
      //   that.leftObj.leftItem01Obj.subTitle.title = "近一周数据";
      //   axios.get("data/weekData.json").then((response) => {
      //     let data = response.data.result || [];
      //     let totalNumber = 0;
      //     let dataValue = [];
      //     data.forEach((item) => {
      //       totalNumber += item.onlineNumber;
      //       dataValue.push([
      //         item.corporateName,
      //         item.model,
      //         item.total,
      //         item.onlineNumber,
      //         item.offlineNumber,
      //       ]);
      //     });
      //     // 在线数统计
      //     that.digitalProcessing(totalNumber);
      //     // 公司飞机类型统计
      //     that.leftObj.leftItem01Obj.config = {
      //       oddRowBGC: "transparent", // 奇数行背景色
      //       evenRowBGC: "rgba(21, 85, 75, 0.2)", // 偶数行背景色
      //       header: ["公司", "机型", "总数", "在线数", "离线数"],
      //       data: dataValue,
      //       align: ["center"],
      //       waitTime: 1500,
      //       rowNum: 8,
      //       columnWidth: [175, 105],
      //     };
      //   });
      // } else if (value == 3) {
      //   that.leftObj.leftItem01Obj.subTitle.title = "近一个月数据";
      //   axios.get("data/monthData.json").then((response) => {
      //     let data = response.data.result || [];
      //     let totalNumber = 0;
      //     let dataValue = [];
      //     data.forEach((item) => {
      //       totalNumber += item.onlineNumber;
      //       dataValue.push([
      //         item.corporateName,
      //         item.model,
      //         item.total,
      //         item.onlineNumber,
      //         item.offlineNumber,
      //       ]);
      //     });
      //     // 在线数统计
      //     that.digitalProcessing(totalNumber);
      //     // 公司飞机类型统计
      //     that.leftObj.leftItem01Obj.config = {
      //       oddRowBGC: "transparent", // 奇数行背景色
      //       evenRowBGC: "rgba(21, 85, 75, 0.2)", // 偶数行背景色
      //       header: ["公司", "机型", "总数", "在线数", "离线数"],
      //       data: dataValue,
      //       align: ["center"],
      //       waitTime: 1500,
      //       rowNum: 8,
      //       columnWidth: [175, 105],
      //     };
      //   });
      // } else if (value == 4) {
      //   that.leftObj.leftItem01Obj.subTitle.title = "近三个月数据";
      //   axios.get("data/threeMonthsData.json").then((response) => {
      //     let data = response.data.result || [];
      //     let totalNumber = 0;
      //     let dataValue = [];
      //     data.forEach((item) => {
      //       totalNumber += item.onlineNumber;
      //       dataValue.push([
      //         item.corporateName,
      //         item.model,
      //         item.total,
      //         item.onlineNumber,
      //         item.offlineNumber,
      //       ]);
      //     });
      //     // 在线数统计
      //     that.digitalProcessing(totalNumber);
      //     // 公司飞机类型统计
      //     that.leftObj.leftItem01Obj.config = {
      //       oddRowBGC: "transparent", // 奇数行背景色
      //       evenRowBGC: "rgba(21, 85, 75, 0.2)", // 偶数行背景色
      //       header: ["公司", "机型", "总数", "在线数", "离线数"],
      //       data: dataValue,
      //       align: ["center"],
      //       waitTime: 1500,
      //       rowNum: 8,
      //       columnWidth: [175, 105],
      //     };
      //   });
      // } else if (value == 5) {
      //   that.leftObj.leftItem01Obj.subTitle.title = "近一年数据";
      //   axios.get("data/yearData.json").then((response) => {
      //     let data = response.data.result || [];
      //     let totalNumber = 0;
      //     let dataValue = [];
      //     data.forEach((item) => {
      //       totalNumber += item.onlineNumber;
      //       dataValue.push([
      //         item.corporateName,
      //         item.model,
      //         item.total,
      //         item.onlineNumber,
      //         item.offlineNumber,
      //       ]);
      //     });
      //     // 在线数统计
      //     that.digitalProcessing(totalNumber);
      //     // 公司飞机类型统计
      //     that.leftObj.leftItem01Obj.config = {
      //       oddRowBGC: "transparent", // 奇数行背景色
      //       evenRowBGC: "rgba(21, 85, 75, 0.2)", // 偶数行背景色
      //       header: ["公司", "机型", "总数", "在线数", "离线数"],
      //       data: dataValue,
      //       align: ["center"],
      //       waitTime: 1500,
      //       rowNum: 8,
      //       columnWidth: [175, 105],
      //     };
      //   });
      // }
    },
    // 用户数点击传递
    childNumberClick(value) {
      switch (value) {
        case 1:
          this.totalClick();
          break;
        case 2:
          this.onLineClick();
          break;
        case 3:
          this.offLineClick();
          break;
        default:
          break;
      }
    },

    // 总数点击事件
    totalClick() {
      this.$bus.$emit("line-list-change", "totalClick");
    },
    // 在线数点击事件
    onLineClick() {
      this.$bus.$emit("line-list-change", "onLineClick", window.__JRSJ__);
    },
    // 离线数点击事件
    offLineClick() {
      this.$bus.$emit("line-list-change", "offLineClick", window.__JRSJ__ZX);
    },
  },
};
</script>

<style scoped lang="scss">
.dataScreen {
  height: 100%;
  background-color: #09152a;
  #container {
    width: 100%;
    height: 100%;
  }
  .div-overlay {
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 9;
    background-image: radial-gradient(
      circle at center,
      rgba(139, 138, 138, 0.22) 30%,
      rgba(9, 21, 42, 0.6) 60%,
      rgba(9, 21, 42, 1) 90%
    );
  }
  .topWrapBox {
    position: fixed;
    top: -3px;
    text-align: center;
    z-index: 19;
    // background: #09152a !important;
    background: rgba(9, 21, 42, 0.8) !important;
  }
  .leftWrapBox {
    position: fixed;
    top: 10vh;
    left: 0;
    margin-left: 1vw;
    z-index: 29;
    // background: #09152a !important;
  }
  .rightWrapBox {
    position: fixed;
    top: 10vh;
    right: 0;
    margin-right: 1vw;
    z-index: 29;
    // background: #09152a !important;
  }
  .bottomWrapBox {
    position: fixed;
    bottom: 0;
    z-index: 19;
    // background: #09152a !important;
  }
}
</style>
